import { Controller } from "@hotwired/stimulus";
import { loadConnectAndInitialize } from "@stripe/connect-js";

import { csrfToken } from "../../../../helpers/utils";

// Connects to data-controller="stripe-embedded-components"
export default class extends Controller {
  static values = {
    sessionPath: String,
    componentType: String,
    publishableKey: String,
  };

  constructor(...args) {
    super(...args);

    this.componentConfigurations = [];
  }

  connect() {
    this.#embedStripeComponent();
  }

  #embedStripeComponent() {
    const component = this.#initializeStripeComponent();

    this.#configureComponent(component);

    this.element.appendChild(component);
  }

  #initializeStripeComponent() {
    const instance = loadConnectAndInitialize({
      publishableKey: this.publishableKeyValue,
      fetchClientSecret: this.#fetchClientSecret,
      fonts: [

      ],
      appearance: {
        overlays: "drawer",
        variables: {
          colorPrimary: "#4E38F8",
          colorText: "#000",
          buttonSecondaryColorBackground: "#D6DDFF",
          buttonSecondaryColorText: "#000000",
          colorSecondaryText: "#6A687F",
          colorBackground: "#FFFFFF",
          actionPrimaryTextDecorationLine: "none",
          actionSecondaryColorText: "#6A687F",
          colorBorder: "#EBEBEB",
          colorDanger: "#BA1A1A",
          badgeNeutralColorBackground: "#EFF2FF",
          badgeNeutralColorBorder: "#E0E5FF",
          badgeNeutralColorText: "#6A687F",
          badgeSuccessColorBackground: "#EEFBF6",
          badgeSuccessColorBorder: "#1A7A54",
          badgeSuccessColorText: "#1A7A54",
          badgeWarningColorBackground: "#FFF7EA",
          badgeWarningColorBorder: "#E68A00",
          badgeWarningColorText: "#E68A00",
          badgeDangerColorBackground: "#FFEDEA",
          badgeDangerColorBorder: "#BA1A1A",
          badgeDangerColorText: "#BA1A1A",
          buttonBorderRadius: "24px",
          overlayBorderRadius: "16px",
          spacingUnit: "10px",
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif'
          // TODO: Change to Mona Sans by providing source for it, see https://docs.stripe.com/js/appendix/custom_font_source_object
          // fontFamily: "Mona Sans"
        },
      },
    });

    return instance.create(this.componentType);
  }

  #fetchClientSecret = async () => {
    const response = await fetch(this.sessionPathValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
      },
    });

    if (!response.ok) {
      // TODO: Handle errors on the client side here
      const { error } = await response.json();
      // TODO: add to error flash
      // document.getElementById("error").classList.remove("hidden");
      return undefined;
    }

    const { client_secret: clientSecret } = await response.json();
    return clientSecret;
  };

  #configureComponent(component) {
    this.componentConfigurations.forEach((configuration) =>
      configuration(component)
    );
  }

  get componentType() {
    return this.componentTypeValue;
  }
}
